<template>
  <div class="statistic-widget-total-sale">
    <h5 class="title mb-3">Total</h5>
    <div class="row no-gutters align-items-center">
      <div class="col-12 col-md-6 content-left row no-gutters pt-3 pb-3 scrollbar">
        <div v-for="item in data" :key="item.currency" class="col-12">
          <div class="widget-content">
            <div class="widget-content-wrapper flex-wrap justify-content-around">
              <div class="widget-content-left ml-2 mr2">
                <div class="widget-heading text-warning">{{ new Intl.NumberFormat().format(item.sale_price || 0) }}</div>
                <div class="widget-subheading">Sales ({{ item.currency }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 widget-chart">
        <div class="widget-numbers">{{ new Intl.NumberFormat().format(total || 0) }}</div>
        <div class="widget-subheading">Total Sales</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return (Object.values(this.config.data) || []).sort((a, b) => {
        if ((a.sale_price || 0) - (b.sale_price || 0) > 0) {
          return -1
        } else if ((a.sale_price || 0) - (b.sale_price || 0) < 0) {
          return 1
        }
        return 0
      })
    },
    total() {
      return Object.values(this.data).reduce((result, current) => result + current.number, 0)
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-total-sale {
  .content-left {
    border-right: #dee2e6 solid 1px;
    max-height: 350px;
    overflow: auto;
  }
  .widget-heading,
  .widget-numbers {
    font-weight: 700;
    font-size: 2rem;
    display: block;
    line-height: 1;
    margin: 1rem auto;
  }
  .widget-numbers {
    font-size: 5rem;
  }
  .widget-subheading {
    text-align: center;
  }
  .widget-content {
    padding: 0;
  }
}
</style>
